<div class="pageheader">
  <div class="typography typography-body grey-700 typography-paragraph" data-testid="hxid-type">
    {{ name }} <span class="tag" data-testid="hxid-number">{{ hxid }} </span>
  </div>
  <h1 class="pageheader-title" data-testid="page-header-title">
    <div
      *ngIf="title" data-testid="back-button"
      class="pageheader-back-button link"
      (click)="toBack()"
    ></div>
    {{ title }}
  </h1>
</div>
